/**
 * Data for the lp-v3 "Superscale brings agentic power to your …" section. Three tabs, switched by the
 * top tab bar and the centre dropdown (kept in sync). Only the CHANNELS tab is real for now; the
 * INTEGRATIONS and AGENTS-MCP tabs are MOCKED placeholders until we have final copy/logos.
 */
export type ChannelCard = {
    title: string
    /** Short capability line; omitted for "coming soon" cards (they show the badge instead). */
    subtitle?: string
    /** One or more brand icons (public paths). Multiple = a combined card (e.g. Reddit + LinkedIn). */
    icons: string[]
    comingSoon?: boolean
}

export type ChannelsTab = {
    id: string
    /** Uppercased in the tab bar. */
    tabLabel: string
    /** Shown in the dropdown button + menu. */
    dropdownLabel: string
    subtitle: string
    cards: ChannelCard[]
}

export const CHANNELS_TABS: ChannelsTab[] = [
    {
        id: 'channels',
        tabLabel: 'Channels',
        dropdownLabel: 'Channels',
        subtitle: 'Analyses the accounts you connect.',
        cards: [
            { title: 'Meta Ads', subtitle: 'Launch creatives that win', icons: ['/icons/metaads.svg'] },
            { title: 'Google Ads', subtitle: 'Shifts spend to what converts', icons: ['/icons/googleads.svg'] },
            { title: 'TikTok Ads', subtitle: "Build videos the viewer won't skip", icons: ['/icons/tiktokads.svg'] },
            { title: 'Reddit and LinkedIn', icons: ['/icons/redditads.svg', '/icons/linkedinads.svg'], comingSoon: true },
        ],
    },
    // MOCK — placeholder content until final integrations copy/logos land.
    {
        id: 'integrations',
        tabLabel: 'Integrations',
        dropdownLabel: 'Integrations',
        subtitle: 'Plugs into the tools your team already uses.',
        cards: [
            { title: 'Shopify', subtitle: 'Build directly on your data', icons: ['/icons/shopify.svg'] },
            { title: 'Klaviyo', subtitle: 'Turns segments into creative', icons: ['/icons/klaviyo.svg'] },
            { title: 'Slack', subtitle: 'Delivers results where you work', icons: ['/icons/slack.svg'] },
            { title: 'Notion', icons: ['/icons/notion.svg'], comingSoon: true },
        ],
    },
    // MOCK — placeholder content until final MCP copy/logos land.
    {
        id: 'agents-mcp',
        tabLabel: 'Agents MCP',
        dropdownLabel: 'Agents-MCP',
        subtitle: 'Let your agent drive Superscale via our MCP.',
        cards: [
            { title: 'Claude', subtitle: 'Run Superscale via Claude', icons: ['/icons/claude.svg'] },
            { title: 'ChatGPT', subtitle: 'Run Superscale via ChatGPT', icons: ['/icons/openai.svg'] },
            { title: 'Codex', subtitle: 'Run Superscale via CodeX', icons: ['/icons/openai.svg'] },
            { title: 'OpenClaw', subtitle: 'Connect your agent', icons: ['/icons/openclaw.svg'] },
        ],
    },
]
